import styled from '@emotion/styled';

export default styled.div({
    display: 'flex',
    flexFlow: 'column wrap',
    justifyContent: 'center'
});
